import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { emailTemplateStatsSchema } from '../models/emailTemplateStats.schema';
import { emailTemplateStatsListQuerySchema } from './list.schema';

export type EmailTemplateStatsListQuery = {
  queue?: number;
  pageSize?: number;
  page?: number;
};

export const list = (query: EmailTemplateStatsListQuery = {}) => {
  return {
    endpoint: `/email_templates/stats`,
    method: 'GET',
    responseSchema: listResponse(emailTemplateStatsSchema),
    query: { ...query, includeTotal: true },
    querySchema: emailTemplateStatsListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
